import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Cache sticky bar and page navigation references
    this.stickyBar = document.querySelector('[data-sticky-bar="course-page-sticky"]')
    this.pageNav = document.querySelector('[aria-label="Page navigation"]')
    
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersection(entries),
      { threshold: 0 }
    )
    
    // Observe this element (the floating box)
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersection(entries) {
    if (!this.stickyBar || !this.pageNav) return // Graceful degradation
    
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Floating box is visible - hide sticky bar and reset page nav position for md+ only
        this.stickyBar.classList.add('hidden')
        this.pageNav.classList.remove('md:top-32')
      } else {
        // Floating box is out of view - show sticky bar and adjust page nav position for md+ only  
        this.stickyBar.classList.remove('hidden')
        this.pageNav.classList.add('md:top-32')
      }
    })
  }
}